var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "disconnected-overlay" }, [
    _c("div", { staticClass: "reveal disconnected-body" }, [
      _c("p", [_vm._v(_vm._s(_vm.message))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.subMessage))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.timer) + "秒後にログイン画面に移動します。")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "disconnected-body__buttons" },
        [
          _c("timer-vue", {
            staticClass: "timer",
            attrs: { duration: _vm.timer * 1000, running: true },
            on: { timeout: _vm.redirectToLogin }
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "button large",
              attrs: { href: _vm.aquariumLoginUrl }
            },
            [_vm._v("ログイン画面へ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }